






















import { Component, Prop, Vue } from "@/shared/vuepack";
import moment from "moment";
import _ from "lodash";
import { useDrivewealthAccountPerformanceStore } from "@/shared/store/drivewealthAccountPerformance";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import {
  DrivewealthAccountIdentifierArgs,
  DrivewealthAccountPerformanceSelectOption,
  DrivewealthAccountPerformanceTimePeriod,
  DrivewealthAccountSummary
} from "@/shared/types";

@Component
export default class AccountPerformanceForm extends Vue {
  drivewealthAccountPerformanceStore = useDrivewealthAccountPerformanceStore();
  drivewealthStore = useDrivewealthStore();

  @Prop()
  accountId: number;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  moment = moment;
  selectedTimePeriod = DrivewealthAccountPerformanceTimePeriod.YearToDate;
  isSubmitting = false;

  mounted (): void {
    this.selectedTimePeriod = this.drivewealthAccountPerformanceStore.selectedTimePeriod;
  }

  get accountIdentifiers (): DrivewealthAccountIdentifierArgs {
    return {
      username: this.username,
      partnerId: this.partnerId,
      accountId: this.accountId
    };
  }

  get accountSummary (): DrivewealthAccountSummary {
    return this.drivewealthStore.accountSummaryById(this.accountId);
  }

  get frequencySelectOptions (): DrivewealthAccountPerformanceSelectOption[] {
    const selectOptions = [];
    Object.keys(DrivewealthAccountPerformanceTimePeriod)
        .forEach(k => {
          const timePeriodOption = DrivewealthAccountPerformanceTimePeriod[k];
          const lookup = _.find(this.timePeriodOptions, x => x.value === timePeriodOption);
          if (moment(this.accountSummary.dateCreated).isBefore(lookup.firstValidDate)) {
            selectOptions.push(lookup);
          }
        });

     return selectOptions;
  }

  get timePeriodOptions (): DrivewealthAccountPerformanceSelectOption[] {
    return [
      {
        text: "YTD",
        value: DrivewealthAccountPerformanceTimePeriod.YearToDate,
        firstValidDate: moment()
      },
      {
        text: "1 M",
        value: DrivewealthAccountPerformanceTimePeriod.Months1,
        firstValidDate: moment().add(-1, "months")
      },
      {
        text: "3 M",
        value: DrivewealthAccountPerformanceTimePeriod.Months3,
        firstValidDate: moment().add(-3, "months")
      },
      {
        text: "6 M",
        value: DrivewealthAccountPerformanceTimePeriod.Months6,
        firstValidDate: moment().add(-6, "months")
      },
      {
        text: "1 Y",
        value: DrivewealthAccountPerformanceTimePeriod.Years1,
        firstValidDate: moment().add(-1, "years")
      },
      {
        text: "MAX",
        value: DrivewealthAccountPerformanceTimePeriod.Max,
        firstValidDate: moment()
      }
    ];
  }

  getAccountPerformance (timePeriod: DrivewealthAccountPerformanceTimePeriod): void {
    this.drivewealthAccountPerformanceStore.setSelectedTimePeriod(timePeriod);
    this.selectedTimePeriod = timePeriod;

    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;

    this.drivewealthAccountPerformanceStore.getAccountPerformance(this.accountIdentifiers);
    this.drivewealthAccountPerformanceStore.getInvestmentBalanceGraphData(this.accountIdentifiers)
      .then(x => this.isSubmitting = false);
  }
}
